'use client';

import { useState } from 'react';
import { CookieSettings } from './CookieSettings';

export function CookiePreferencesButton() {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const openSettings = () => setIsSettingsOpen(true);
  const closeSettings = () => setIsSettingsOpen(false);

  return (
    <>
      <button 
        onClick={openSettings}
        className="text-sm hover:text-[#F1EFEC] hover:underline transition-colors"
      >
        Cookie Preferences
      </button>
      <CookieSettings isOpen={isSettingsOpen} onClose={closeSettings} />
    </>
  );
} 